<default-popup-wrapper-component [globalPopup]="globalPopup"
                                 [title]="globalPopup.title"
                                 (onClose)="closePopup($event)"
                                 [componentRef]="this">
    <p [innerHTML]="'popup-refresh-request.body' | translate"></p>
</default-popup-wrapper-component>

